import api from '../api';
import { buildApiHeaders } from '../../utilities/configUtils';

export const fetchAssetTimeZoneAsync = async (assetId: string) => {
  const params = {
    assetId: assetId,
  };

  const headers = await buildApiHeaders();
  return await api
    .get('/AssetData/GetAssetTimeZone', {
      params,
      headers,
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    });
};
